const StateTranslate = ({ text, trasform }) => {
  switch (text) {
    case "CREATE":
      text = "Creato";
      break;
    case "OPEN":
      text = "Aperto";
      break;
    case "CLOSED":
      text = "Chiuso";
      break;
    case "ARCHIVED":
      text = "Archiviato";
      break;
    default:
      text = "";
  }
//console.log(trasform);

  switch (trasform) {
    case "U":
      text = text?.toString().toUpperCase();
      break;
    case "C":
     
      text = text?.toString().charAt(0).toUpperCase() + text?.slice(1);
      break;
    case "L":
      text = text?.toString().toLowerCase();
      break;
    default:
      text = text;
  }

 return <>{text}</>;
};
export default StateTranslate;
